<script setup>

import {mdiAccount, mdiListBoxOutline, mdiLogout, mdiTabletCellphone} from "@mdi/js";
import {getCsrfToken} from "../../csrf";
import {currentUser} from "@/infrastructure/user";
import {Permissions} from "@/infrastructure/permissions";
import {computed} from "vue";
import {staticUrl} from "@/url";

const props = defineProps({
    drawer: {
        type: Boolean,
        required: true
    },
    hpoMember: {
        type: Object,
    },
})
const emit = defineEmits(['setDrawer'])
const csrfToken = getCsrfToken()

const userName = computed(() => {
    if (props.hpoMember) {
        return props.hpoMember.name;
    }
    if (currentUser.lastName || currentUser.firstName) {
        return `${currentUser.lastName} ${currentUser.firstName}`;
    }
    return null;
});

function emitSetDrawer(value) {
    emit('update:drawer', value)
}
</script>

<template>
    <v-navigation-drawer class="pt-4" color="grey-lighten-3" :modelValue="drawer" @update:modelValue="emitSetDrawer">
        <v-list density="compact" nav>
            <slot></slot>

            <v-list-item :prepend-icon="mdiListBoxOutline" :title="pgettext('label', 'Hpo List')"
                         :to="{name: 'hpo:list'}"></v-list-item>
            <v-list-item v-if="currentUser.hasPermission(Permissions.DEVICE__MANAGE)"
                         :prepend-icon="mdiTabletCellphone" :title="pgettext('label', 'Devices')"
                         :to="{name: 'device:manage'}"></v-list-item>

            <div v-if="userName" class="text-center mt-10 mb-4">
                <v-chip :prepend-icon="mdiAccount" rounded>
                    <strong>{{ userName }}</strong>
                </v-chip>
            </div>
            <v-list-item :class="{'mt-10': !userName}" :prepend-icon="mdiLogout" base-color="red-darken-1"
                         variant="elevated" rounded>
                <form :action="reverseUrl('web:account:logout')" method="POST">
                    <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken"/>
                    <v-btn color="red-darken-1" block type="submit">
                        {{ pgettext('action', 'Logout') }}
                    </v-btn>
                </form>
            </v-list-item>

            <form class="mt-6" :action="reverseUrl('web:set_language')" method="POST">
                <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken"/>
                <div class="d-flex ga-2 justify-center">
                    <button type="submit" name="language" value="en">
                        <img :src="staticUrl('svg/country-flags/us.svg')" height="16" alt="English" />
                    </button>
                    <button type="submit" name="language" value="cs">
                        <img :src="staticUrl('svg/country-flags/cz.svg')" height="16" alt="Czech" />
                    </button>
                    <button type="submit" name="language" value="de">
                        <img :src="staticUrl('svg/country-flags/de.svg')" height="16" alt="German" />
                    </button>
                </div>
            </form>
        </v-list>
    </v-navigation-drawer>
</template>

<style scoped>

</style>
